import { render, staticRenderFns } from "./ModuleSelector.vue?vue&type=template&id=37f62df1&scoped=true&"
import script from "./ModuleSelector.vue?vue&type=script&lang=js&"
export * from "./ModuleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f62df1",
  null
  
)

export default component.exports